/**
 * Triggers a browser download for a blob.
 * @param {Blob} blob - File blob to download.
 * @param {string} filename - Name for the downloaded file.
 */
export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  setTimeout(() => URL.revokeObjectURL(url), 100)
}

/**
 * Downloads JSON data as a file with pretty-printed content.
 * @param {object} data - Data to serialize as JSON.
 * @param {string} filename - Name for the downloaded file.
 */
export const downloadJson = (data, filename) => {
  const blob = new Blob([JSON.stringify(data, null, 2)], {
    type: 'application/json',
  })
  downloadBlob(blob, filename)
}
